<template>
    <ModalWrapper v-model="modal" :fullscreen="$breakpoint.smAndDown" max-width="900" data-cy="modal" scrollable>
        <template v-slot:activator>
            <v-btn data-cy="create" color="primary" v-bind="props" @click="modal = true">{{ $t('create') }}</v-btn>
        </template>
        <template v-slot:title>
            {{ $t('select_price_list_type') }}
        </template>
        <template v-slot:content>
            <v-radio-group v-model="priceCode" hide-details>
                <v-radio v-for="code in priceListCodes" :key="code" :value="code" color="primary" :data-cy="code">
                    <template v-slot:label>
                        <v-col>
                            <div class="text-subtitle-2">
                                {{ $t(`priceListCodeTitle.${code}`) }}
                            </div>
                            <div
                                class="text-caption text-medium-emphasis"
                                v-html="$t(`priceListCodeSubTitle.${code}`).replace(/\n/g, '<br>')"
                            />
                        </v-col>
                    </template>
                </v-radio>
            </v-radio-group>
        </template>
        <template v-slot:btns>
            <v-btn variant="flat" color="primary" class="text-none" data-cy="continue" @click="selectPriceList">
                {{ $t('continue') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    const props = defineProps<{
        priceListCodes: string[]
    }>()

    const priceCode = defineModel<string>({
        default: '',
    })

    const modal = ref<boolean>(false)

    const emit = defineEmits<{
        (e: 'continue'): void
    }>()

    watch(
        () => modal.value,
        () => {
            if (modal.value) priceCode.value = props.priceListCodes[0]
        }
    )

    const selectPriceList = () => {
        modal.value = false
        emit('continue')
    }

    defineExpose({
        modal,
    })
</script>
<style lang="scss" scoped>
    :deep(br) {
        content: '';
        display: block;
        margin-bottom: 0.5rem !important;
    }
    :deep(.v-label) {
        opacity: 1;
    }
</style>
